/**
 * State for email
 */
export const state = {
  /**
   * Weather the email is group email
   * True or False
   */
  // permittedUsers: false,

  /**
   * All the email folder of users
   *
   * Format
   * {
   *   "emailFolder": [{
   *     "folderId": 159,
   *     "folderName": "A parent folder 1",
   *     "parentId": 0,
   *     "expandFlag": 0,
   *     "folders": [{
   *       "folderId": 161,
   *       "folderName": "child under p1",
   *       "parentId": 159,
   *       "expandFlag": 0,
   *       "folders": [{
   *         "folderId": 163,
   *         "folderName": "1",
   *         "parentId": 161,
   *         "expandFlag": 0,
   *         "folders": [{
   *           "folderId": 164,
   *           "folderName": "2",
   *           "parentId": 163,
   *           "expandFlag": 0
   *         }]
   *       }]
   *     }]
   *   }]
   * }
   */
  emailFolder: false,

  /**
   * All the signatures of user
   *
   * Format
   * {
   *   "signatures": [
   *      {
   *        "id": 0,
   *        "signature": "No signature",
   *        "is_default": 0
   *      },
   *      {
   *        "id": 3,
   *        "signature": "\003E",
   *        "is_default": 0
   *     }
   *   ]
   * }
   */
  signatures: [],

  /**
   * All the emails of user
   *
   * Format
   * {
   *   "inbox": {
   *     "list": [
   *       {
   *         boxType: "Inbox",
   *         boxUserId: 3159,
   *         color: "",
   *         folderId: 0,
   *         from: "sipra, mobile2",
   *         isFavourite: "1",
   *         mailBoxId: 1166,
   *         message: "<p>Hey</p>",
   *         readStatus: 1,
   *         repliedStatus: 0,
   *         sub: "123",
   *         time: "11:57 am"
   *      }
   *     ],
   *     page: 1,
   *     additionalOffset: 0,
   *     isFewPagesLoaded: false,
   *     isAllPagesLoaded: false,
   *     loading: false
   *   },
   *   "custom": {
   *     "1": [
   *       {
   *         boxType: "Inbox",
   *         boxUserId: 3159,
   *         color: "",
   *         folderId: 0,
   *         from: "sipra, mobile2",
   *         isFavourite: "1",
   *         mailBoxId: 1166,
   *         message: "<p>Hey</p>",
   *         readStatus: 1,
   *         repliedStatus: 0,
   *         sub: "123",
   *         time: "11:57 am"
   *       }
   *     ],
   *     page: 1,
   *     additionalOffset: 0,
   *     isFewPagesLoaded: false,
   *     isAllPagesLoaded: false,
   *     loading: false
   *   }
   * }
   */
  emails: {
    inbox: {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    },
    sent: {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    },
    unread: {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    },
    custom: {
    },
    draft: {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    },
    trash: {
      list: [],
      page: 1,
      additionalOffset: 0,
      isFewPagesLoaded: false,
      isAllPagesLoaded: false,
      loading: false
    }
  },

  /**
   * Array to keep track of unread mail ids.
   *
   * Format
   * [3159, 3187]
   */
  unreadMailIds: {},

  /**
   * Boolean flag to keep track of favourite mode
   *
   * Format
   * true/false
   */
  favouriteMode: false,

  /**
   * The currently selected personal folder
   */
  selectedCustomFolderName: null,

  /**
   * The initial mail details, Which will be set when clicking reply/reply-all/forward
   */
  initialMailDetail: null,

  /**
   * Boolean flag to determine loading state for all email related pages
   */
  composeEmailLoading: false,

  /**
   * Array to store the contact list of loggedin user
   *
   * Format
   * [
   *  {
   *    email: "sipra.testing+mobile2@gmail.com"
   *    id: 3159,
   *    name: "sipra, mobile2 (You)",
   *    subscriberId: 0,
   *    type: 0
   *  }
   * ]
   */
  contactList: false,

  /**
   * The number to show for inbox/unread folder on mailbox page
   */
  boxCount: {
    inbox: 0,
    unread: 0,
    needLoad: true
  },

  /**
   * Sets the selected user id from dropdown
   */
  selectedUserId: 0,

  /**
   * Sets the subscriber id.
   */
  subscriberId: 0,

  /**
   * Sets the app user
   */
  appUsers: [],

  /**
   * Unread mail count on other pages
   */
  unreadMailCountOnOtherPage: 0
};
